import gsap from 'gsap';
import { Observer } from 'gsap/Observer';
import { $window } from '../../helpers/globalVars';
import { horizontalLoop } from '../../helpers/horizontalLoop';

const handler = ( $ ) => {
	gsap.registerPlugin( Observer );

	const $ticker = $( '.ticker' ),
		$tickerList = $( '.ticker__list', $ticker ),
		$items = $( '.ticker__item', $ticker );

	if ( $items.length == 0 ) {
		return;
	}

	let $itemsDirLeft = $items.filter( '[data-direction="left"]' ),
		$itemsDirRight = $items.filter( '[data-direction="right"]' );

	const speed = $ticker.data( 'speed' ),
		config = {
			speed,
			repeat: -1,
		};

	if ( $window.width() < 992 ) {
		config.speed = speed / 2;
	}

	let tlLeft = null,
		tlRight = null,
		doubleWindowWidth = $window.width() * 2;

	const cloneItems = ( $_items, direction ) => {
		let $newItems = $_items,
			itemsTotalWidth = 0,
			margin = 0;

		$_items.each( ( _, item ) => {
			itemsTotalWidth += $( item ).outerWidth();
		} );

		margin = doubleWindowWidth - itemsTotalWidth;

		if ( margin > 0 ) {
			$_items.each( ( _, item ) => {
				const $item = $( item ),
					$itemClone = $item.clone();

				$itemClone.appendTo( $item.parents( '.ticker__list' ) );

				$newItems = $newItems.add( $itemClone );

				itemsTotalWidth += $item.width();
			} );

			margin = doubleWindowWidth - itemsTotalWidth;
		}

		if ( margin > 0 ) {
			cloneItems( $newItems, direction );
		}

		return $newItems;
	};

	if ( $itemsDirLeft.length > 0 ) {
		$itemsDirLeft = cloneItems( $itemsDirLeft, 'left' );

		tlLeft = horizontalLoop( $itemsDirLeft, config );
	}

	if ( $itemsDirRight.length > 0 ) {
		$itemsDirRight = cloneItems( $itemsDirRight, 'right' );

		tlRight = horizontalLoop( $itemsDirRight, {
			...config,
			reversed: true,
		} );
	}

	let speedTweenLeft,
		speedTweenRight,
		isToRight = false;

	const onHoverHandler = ( self ) => {
		const $targetItems = $( self.target ).children();

		isToRight = $targetItems.data( 'direction' ) == 'right';

		if ( isToRight ) {
			if ( ! tlRight ) {
				return;
			}
			speedTweenRight && speedTweenRight.kill();
			speedTweenRight = gsap.timeline().to( tlRight, {
				timeScale: -0.3,
			} );
		} else {
			if ( ! tlLeft ) {
				return;
			}
			speedTweenLeft && speedTweenLeft.kill();
			speedTweenLeft = gsap.timeline().to( tlLeft, {
				timeScale: 0.3,
			} );
		}
	};

	const onHoverEndHandler = () => {
		if ( isToRight ) {
			if ( ! tlRight ) {
				return;
			}

			speedTweenRight && speedTweenRight.kill();
			speedTweenRight = gsap.timeline().to( tlRight, {
				timeScale: -1,
			} );
		} else {
			if ( ! tlLeft ) {
				return;
			}

			speedTweenLeft && speedTweenLeft.kill();
			speedTweenLeft = gsap.timeline().to( tlLeft, {
				timeScale: 1,
			} );
		}
	};

	const anim = ( _, tickerList ) => {
		Observer.create( {
			target: tickerList,
			type: 'pointer',
			onHover: onHoverHandler,
			onHoverEnd: onHoverEndHandler,
		} );
	};

	$tickerList.each( anim );

	const windowResizeHandler = () => {
		speedTweenRight && speedTweenRight.kill();
		speedTweenLeft && speedTweenLeft.kill();

		speedTweenLeft = gsap.timeline().to( tlLeft, {
			timeScale: 1,
		} );
		speedTweenRight = gsap.timeline().to( tlRight, {
			timeScale: -1,
		} );
	};

	$window.on( 'resize', windowResizeHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
